import { Table } from '@tanstack/react-table';
import { CustomPagination } from '@repo/ui/components/carsList/CustomPagination';

interface DataTablePaginationProps<TData> {
    table: Table<TData>;
    totalCount: number;
}

export function DataTablePagination<TData>({ table, totalCount }: DataTablePaginationProps<TData>) {
    // Calculate the range of records being displayed
    const pageIndex = table.getState().pagination.pageIndex;
    const pageSize = table.getState().pagination.pageSize;
    // const pageCount = table.getPageCount();

    // If we have no data, show appropriate message
    if (table.getFilteredRowModel().rows.length === 0) {
        return null;
    }

    // Calculate start and end record numbers
    const startRecord = pageIndex * pageSize + 1;
    const endRecord =
        10 * (pageIndex + 1) > totalCount
            ? totalCount
            : Math.min(startRecord + pageSize - 1, (pageIndex + 1) * pageSize);

    return (
        <div className="flex items-center justify-between px-4 py-3">
            <div className="flex-1 font-normal text-primery-blue-600 text-base leading-7 tracking-normal">
                عرض {startRecord} إلى {endRecord} من {totalCount}
                {table.getFilteredSelectedRowModel().rows.length > 0 && (
                    <span>
                        , {table.getFilteredSelectedRowModel().rows.length} من {table.getFilteredRowModel().rows.length}{' '}
                        صف (صفوف) محدد.
                    </span>
                )}
            </div>
            <div className="flex items-center space-x-6 lg:space-x-8">
                <div className="flex items-center space-x-2">
                    <CustomPagination
                        totalItems={totalCount}
                        itemsPerPage={10}
                        currentPage={table.getState().pagination.pageIndex + 1}
                        onPageChange={(page) => table.setPageIndex(page - 1)}
                    />
                </div>
            </div>
        </div>
    );
}
